import { render, staticRenderFns } from "./Doctors.vue?vue&type=template&id=5cde802e&"
import script from "./Doctors.vue?vue&type=script&lang=js&"
export * from "./Doctors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports